import React, { useState } from "react"
import Styles from "./MvaRegistrertLenke.module.css"
import { mvaRegistrert } from "../konto/mvaRegistrert"
import { useGeneratePath } from "./useGeneratePath"
import { useParams, Link } from "react-router-dom"

export default function MvaRegistrertLenke(): React.ReactElement {
  const params = useParams()
  const { medMva, utenMva } = mvaRegistrert
  const [erMedMva, setErMedMva] = useState<boolean>(medMva === params.medMva)
  const mva = erMedMva ? utenMva : medMva
  const to = useGeneratePath({ medMva: mva }, [erMedMva])

  return (
    <Link to={to} className={`${Styles.momsRegistrertLenke}`} onClick={() => setErMedMva(!erMedMva)}>
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect
          x="1"
          y="1"
          width="15"
          height="15"
          rx="3"
          style={{
            stroke: erMedMva ? "var(--fiken-color-green-700)" : "var(--fiken-color-black-500)",
          }}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {erMedMva && (
          <path
            d="M5 8L8 11L12 5"
            stroke="var(--fiken-color-green-700)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </svg>
      <span>Mva-registrert</span>
    </Link>
  )
}
